import { useLocation } from 'react-router-dom';

import { RegistrationMethod } from 'components/registration/hooks/useRegistrationSuccessEffect';
import URL from 'url-parse';

import { redirect } from '../../lib/navigation';
import { getLocationQuery } from '../../lib/url';
import eventTracking from '../../services/analytics/eventTracking';
import {
    composeSuccessLoginDataLayerPayload,
    gTag,
} from '../../services/google/tagManager';

export const useLoginSuccessEffect = () => {
    const location = useLocation();

    return (
        nextUrl: string,
        is2faEnabled = false,
        method?: RegistrationMethod,
    ) => {
        gTag(composeSuccessLoginDataLayerPayload());
        const { source, redirect: redirectLink } = getLocationQuery(location);

        const sourceLink = source === 'edi' ? 'edi' : null;

        let url = '';
        let urlIsSafe = true;
        if (redirectLink) {
            const rawUrl = URL(redirectLink);
            urlIsSafe =
                rawUrl.host.endsWith('.vchasno.ua') ||
                rawUrl.host.endsWith('.vchasno.stg.evo') ||
                rawUrl.host.endsWith('.vchasno.com.ua') ||
                ['vchasno.ua', 'vchasno.stg.evo', 'vchasno.com.ua'].includes(
                    rawUrl.host,
                );
        }
        if (!urlIsSafe) {
            url = nextUrl;
        } else if (is2faEnabled) {
            url = redirectLink
                ? `${nextUrl}?redirect=${redirectLink}`
                : nextUrl;
        } else {
            url = redirectLink || nextUrl;
        }

        if (
            ['google', 'microsoft', 'apple'].includes(
                method as RegistrationMethod,
            )
        ) {
            eventTracking.sendToGTM({
                event: `${method}_login_success`,
                category: `${method}_login_success`,
                action: '',
            });

            redirect(url);
        } else {
            eventTracking.sendEvent('login', 'finish', sourceLink, () =>
                redirect(url),
            );
        }
    };
};
